import LinearPlans from "./LinearPlans";

export default LinearPlans;
